// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── page-flip engine base rules ──────────────────────────────────────────
   react-pageflip/page-flip don't ship a bundled stylesheet — these are the
   handful of structural rules the flip engine's canvas/shadow layers need
   to position themselves correctly (copied from page-flip's own base CSS). */
.stf__parent {
  position: relative;
  display: block;
  box-sizing: border-box;
  transform: translateZ(0);
  touch-action: pan-y;
  /* Belt-and-suspenders clip: the engine's own clip-path on each flipping
     page is occasionally a sub-pixel short of the page edge mid-animation,
     letting a thin sliver of page color peek past the book's own box for a
     frame or two. Clipping the whole book container catches that instead
     of it reading as a stray fragment floating outside the page. */
  overflow: hidden;
}

.stf__parent canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.stf__block {
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  perspective: 2000px;
}

.stf__item {
  display: none;
  position: absolute;
  transform-style: preserve-3d;
}

.stf__outerShadow,
.stf__innerShadow,
.stf__hardShadow,
.stf__hardInnerShadow {
  position: absolute;
  left: 0;
  top: 0;
}

/* ── Preview overlay ──────────────────────────────────────────────────── */
.pf-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(20, 20, 24, 0.94);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.pf-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  flex-shrink: 0;
}

.pf-title {
  color: #f5f5f5;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.02em;
}

.pf-close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #f5f5f5;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.pf-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.pf-stage {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 0;
  padding: 0 12px;
}

.pf-flipbook {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.pf-arrow {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 26px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, opacity 0.15s;
}

.pf-arrow:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.22);
}

.pf-arrow:disabled {
  opacity: 0.25;
  cursor: default;
}

.pf-bottombar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 14px 20px 22px;
  flex-shrink: 0;
}

.pf-counter {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.pf-order-btn {
  background: #2d3748;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.pf-order-btn:hover {
  background: #1a202c;
}

/* ── Page faces rendered inside the flip book ────────────────────────── */
.pf-page {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  /* Must be absolute, not relative: page-flip adds its own ".stf__item"
     class to this very element and expects position:absolute so it can
     pull it out of normal flow (it positions pages purely via inline
     \`transform\`, not left/top, while mid-flip). With \`relative\` here, the
     equal-specificity ".pf-page" rule beat ".stf__item"'s in the cascade,
     so flipping pages stayed IN DOCUMENT FLOW and stacked one below the
     book (visible as photos flashing outside it during the page turn),
     even though the resting/simple-page state looked fine (page-flip sets
     \`position: absolute\` inline for that state, which always wins). */
  position: absolute;
}

@media (max-width: 700px) {
  .pf-title { display: none; }
  .pf-arrow { width: 36px; height: 36px; font-size: 20px; }
  .pf-stage { gap: 6px; padding: 0 4px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PhotoBook/PhotoBookPreview.css"],"names":[],"mappings":"AAAA;;;6EAG6E;AAC7E;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EAExB,mBAAmB;EACnB;;;;mEAIiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;;;EAIE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB;;;;;;;;sEAQoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,YAAY,aAAa,EAAE;EAC3B,YAAY,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;EACxD,YAAY,QAAQ,EAAE,cAAc,EAAE;AACxC","sourcesContent":["/* ── page-flip engine base rules ──────────────────────────────────────────\n   react-pageflip/page-flip don't ship a bundled stylesheet — these are the\n   handful of structural rules the flip engine's canvas/shadow layers need\n   to position themselves correctly (copied from page-flip's own base CSS). */\n.stf__parent {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  transform: translateZ(0);\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  /* Belt-and-suspenders clip: the engine's own clip-path on each flipping\n     page is occasionally a sub-pixel short of the page edge mid-animation,\n     letting a thin sliver of page color peek past the book's own box for a\n     frame or two. Clipping the whole book container catches that instead\n     of it reading as a stray fragment floating outside the page. */\n  overflow: hidden;\n}\n\n.stf__parent canvas {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.stf__block {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  perspective: 2000px;\n}\n\n.stf__item {\n  display: none;\n  position: absolute;\n  transform-style: preserve-3d;\n}\n\n.stf__outerShadow,\n.stf__innerShadow,\n.stf__hardShadow,\n.stf__hardInnerShadow {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n/* ── Preview overlay ──────────────────────────────────────────────────── */\n.pf-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(20, 20, 24, 0.94);\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.pf-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  flex-shrink: 0;\n}\n\n.pf-title {\n  color: #f5f5f5;\n  font-weight: 600;\n  font-size: 15px;\n  letter-spacing: 0.02em;\n}\n\n.pf-close-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  color: #f5f5f5;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.pf-close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.pf-stage {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  min-height: 0;\n  padding: 0 12px;\n}\n\n.pf-flipbook {\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.pf-arrow {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  font-size: 26px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.pf-arrow:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.pf-arrow:disabled {\n  opacity: 0.25;\n  cursor: default;\n}\n\n.pf-bottombar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 14px 20px 22px;\n  flex-shrink: 0;\n}\n\n.pf-counter {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.pf-order-btn {\n  background: #2d3748;\n  color: #fff;\n  border: none;\n  padding: 10px 22px;\n  border-radius: 24px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.pf-order-btn:hover {\n  background: #1a202c;\n}\n\n/* ── Page faces rendered inside the flip book ────────────────────────── */\n.pf-page {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  overflow: hidden;\n  /* Must be absolute, not relative: page-flip adds its own \".stf__item\"\n     class to this very element and expects position:absolute so it can\n     pull it out of normal flow (it positions pages purely via inline\n     `transform`, not left/top, while mid-flip). With `relative` here, the\n     equal-specificity \".pf-page\" rule beat \".stf__item\"'s in the cascade,\n     so flipping pages stayed IN DOCUMENT FLOW and stacked one below the\n     book (visible as photos flashing outside it during the page turn),\n     even though the resting/simple-page state looked fine (page-flip sets\n     `position: absolute` inline for that state, which always wins). */\n  position: absolute;\n}\n\n@media (max-width: 700px) {\n  .pf-title { display: none; }\n  .pf-arrow { width: 36px; height: 36px; font-size: 20px; }\n  .pf-stage { gap: 6px; padding: 0 4px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
